import {BehaviorBase} from "PageBuilder/pagebuilder/Controls/Behaviors/BehaviorBase";
import {ColumnItem} from "PageBuilder/pagebuilder/Controls/ControlsList/TableControl/ColumnItem";

export class ColumnBehavior extends BehaviorBase{
    constructor(public column:ColumnItem) {
        super();
    }

    public get IsDraggable(){
        return false;
    }
    OnGenerate(container: HTMLElement) {
        container.style.position='static';
        container.style.width='100%';
        container.style.height='100%';
    }


    OnSelect() {
        this.column.RowItem.TableItem.SelectColumn(this.column);
        this.Control.$element.css('border','none');
    }


    OnDeSelect() {
        this.column.RowItem.TableItem.DeselectColumn(this.column);
    }
}